module.exports = __webpack_public_path__ + "img/cube.a73c4c40.svg";